module.exports = __webpack_public_path__ + "img/cb_K3.9a474e96.svg";